import React, { useState } from 'react';
import { Box, Container, useMediaQuery, useTheme } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import Sidebar from './Sidebar';
import BottomNav from './BottomNav';

function Layout({ children, user, onLogout }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header user={user} onLogout={onLogout} onMenuClick={handleDrawerToggle} />
      <Box sx={{ display: 'flex', flex: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
        {user && <Sidebar user={user} mobileOpen={mobileOpen} onDrawerToggle={handleDrawerToggle} />}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: { xs: 2, sm: 3 },
            width: { xs: '100%', sm: `calc(100% - 240px)` },
            maxWidth: '100%',
            overflowX: 'auto',
            pb: { xs: 10, sm: 3 }, // Add bottom padding on mobile to account for bottom nav
          }}
        >
          {children}
        </Box>
      </Box>
      {!isMobile && <Footer />}
      <BottomNav user={user} />
    </Box>
  );
}

export default Layout;

